var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppTypeDigital(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17532",
    fill: "none",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12958",
    d: "M12.666 8V5.219a1.334 1.334 0 00-.391-.943L10.39 2.391A1.334 1.334 0 009.448 2H4.666a1.333 1.333 0 00-1.333 1.333v9.333A1.333 1.333 0 004.666 14h2.667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12959",
    d: "M5.333 6h5.333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12960",
    d: "M5.333 8h5.333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12961",
    d: "M5.333 10h1.333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Mobile, Devices, Charging",
    strokeWidth: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12970",
    d: "M11.626 15.252A2.626 2.626 0 019 12.626 2.667 2.667 0 0111.628 10a2.626 2.626 0 010 5.252"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12971",
    d: "M11.917 11.459l-.875.875 1.167.584-.875.875",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12964",
    d: "M0 0h16v16H0z",
    fill: "none"
  })));
}
export default SvgAppTypeDigital;


//////////////////
// WEBPACK FOOTER
// ./src/icons/appType-Digital.svg
// module id = 450
// module chunks = 11